import urlPrefixes from '../../../constants/urlPrefixes';
import createURLComponent from '../createURLComponent';

type TAttributeParams = {
  attributeValueLabel: string;
  attributeValueId: number | string;
};

/**
 * create attributes part (SEO friendly part)
 * p.s. must include max 2 attributes (for more details check: getSortedAttributes function)
 * includes Alphabetically order logic
 */
export default (attributes: TAttributeParams[]): string => {
  if (Array.isArray(attributes) && attributes.length) {
    const labels = attributes
      .map((attr) => createURLComponent(attr.attributeValueLabel))
      .join(urlPrefixes.seoFriendlyMergeKey);
    const ids = attributes.map((attr) => attr.attributeValueId).join(urlPrefixes.seoFriendlyMergeKey);
    return `/${urlPrefixes.attributes}/${labels}/${ids}`;
  }
  return '';
};
